import { ExtraCostsPreviewOutDTO } from '@api/ringil-api.v2';
import { formatPrice } from '@utils/priceUtils.ts';

// Shared so the section heading and the component itself cannot drift apart.
export const extraCostsTotal = (contractualPrice: number | undefined, costs: ExtraCostsPreviewOutDTO[]) =>
  formatPrice(contractualPrice, costs?.length > 0 ? costs[0].priceDTO?.currency : '');
